import { render, staticRenderFns } from "./liaison.vue?vue&type=template&id=96a58364&"
import script from "./liaison.vue?vue&type=script&lang=js&"
export * from "./liaison.vue?vue&type=script&lang=js&"
import style0 from "./liaison.vue?vue&type=style&index=0&id=96a58364&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports